import { useEffect } from 'react';
import {
  Dialog,
  ButtonSize,
  Typography,
  ButtonVariant,
  PrimaryButton,
  SecondaryButton,
} from '@uni-of-exeter/digital.lib.react.ui.kit';

import './continue-modal.css';

// ------------------------------------------------------------

export interface ContinueResourceModalProps {
  isOpen: boolean;
  onContinue: () => void;
  onClose: () => void;
  title: string;
  body: string;
  primaryButtonText: string;
  secondaryButtonText: string;
  footerText?: string;
}

const ContinueModal = ({
  isOpen,
  onClose,
  onContinue,
  title,
  body,
  primaryButtonText,
  secondaryButtonText,
  footerText,
}: ContinueResourceModalProps) => {
  useEffect(() => {
    const rootElement = document.getElementById('root');
    if (!rootElement) return;

    if (isOpen) {
      rootElement.style.filter = 'blur(4px)';
    } else {
      rootElement.style.filter = '';
    }

    return () => {
      if (rootElement) {
        rootElement.style.filter = '';
      }
    };
  }, [isOpen]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      footer={<></>}
      className="continueModal"
    >
      <div
        className="continueModalWrapper"
        aria-modal
        role="alertdialog"
        aria-label="continue Resource Modal"
      >
        <div className="continueModalContent">
          <Typography
            variant="h2"
            fontWeight={700}
          >
            {title}
          </Typography>
          <div>
            <Typography variant="body">{body}</Typography>
          </div>
        </div>
        <div className="continueModalFooter">
          <div className="secondaryText">
            <Typography variant="body.small">{footerText}</Typography>
          </div>
          <div className="buttonsContainer">
            <SecondaryButton
              variant={ButtonVariant.Outline}
              size={ButtonSize.Large}
              onClick={onClose}
            >
              {secondaryButtonText}
            </SecondaryButton>
            <PrimaryButton
              variant={ButtonVariant.Solid}
              size={ButtonSize.Large}
              onClick={onContinue}
              icon={<i className={`fa-regular fa-thumbs-up thumbIcon`} />}
            >
              {primaryButtonText}
            </PrimaryButton>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ContinueModal;
